export default __webpack_public_path__ + "static/media/chart.ffc6b8c9.svg";